import { LOG_OUT } from "../login/action";
import { SET_CIATATION_PDF_STATES, SET_ORDER__PDF_STATES } from "./action";

export const defaultState={
    driverOrderPDFStateList:{}
}

function driverOrderPDFReducer(state=defaultState,action){
    switch (action.type) {
       case SET_ORDER__PDF_STATES:
           return{
               ...state,
               driverOrderPDFStateList:action.payload
           }
        case LOG_OUT:
            return defaultState;
        default:
          return state;
      }
}

export default driverOrderPDFReducer;